import React from 'react';
import { useCookies } from 'react-cookie';

import Container from './components/Container';

import './App.css';

export default function App() {
	const [cookies, setCookie] = useCookies([]);
	const [currentUser, setCurrentUser] = React.useState(false);
	const [currentGroupId, setCurrentGroupId] = React.useState(false);
	const [groups, setGroups] = React.useState([]);
	const [count, setCount] = React.useState(0);
    const [sentMessage, setSentMessage] = React.useState(false);

	const callAPI = (theData) => {
		// Parameters to send along with request to the api
		const theParams = {
			method: "POST",
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(theData)
		};

		return fetch(process.env.REACT_APP_ENDPOINT, theParams);

	};

	const updateGroupStatus = (data) => {
		const { from, group } = data;

		const changeStatus = (value) => {
			const updatedGroup = groups.find(g => g.id === group.id);

			// Set group status
			updatedGroup.online = value;
			
			// Save state (groups)
			const newState = groups.map((group) => {
				if (group.id === updatedGroup.id) {
					return updatedGroup;
				}
				
				return group;
			});

			setGroups(newState);
		}

		changeStatus(from.name + " is typing..");

		setTimeout(() => {
			// undo status change
			changeStatus(false);
		}, 500);
	};

	const setGroup = (group) => {		
		const groupId = group ? group.id : 0;

		setCookie("group_id", groupId);
		setCurrentGroupId(group);
	};

	return (
		<div className={ currentGroupId ? "main-wrapper group-opened" : "main-wrapper" }>
			<Container
				cookies={cookies}
				setCookie={setCookie}
				callAPI={callAPI}
				currentUser={currentUser}
				setCurrentUser={setCurrentUser}
				groups={groups}
				setGroups={setGroups}
				currentGroupId={currentGroupId}
				setGroup={setGroup}
				showIsTyping={updateGroupStatus}

				count={count}
				setCount={setCount}
				sentMessage={sentMessage}
				setSentMessage={setSentMessage}
			/>
		</div>
	);
}
